import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { createSelector, Store } from '@ngrx/store';
import { QuillEditorComponent, QuillModules } from 'ngx-quill';

import { MenuItem } from 'primeng/api';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { Delta } from 'quill/core';

import { SubSink } from 'subsink';


import { QuillTemplate, QuillTemplateLocation } from '../../../../../generated/graphql.generated';
import { FreyaCommonModule } from '../../../../freya-common/freya-common.module';
import { commentDefaultToolbar } from '../../../../jobsv2/job-activity/comments.utils';
import { TEMPLATE_VARIABLES } from '../../../../jobsv2/job-activity/quill-modules/quill-templates.helpers';
import { QuillVariable, VariableToolbarQuillModule } from '../../../../jobsv2/job-activity/quill-modules/variableToolbar.quillModule';
import { QuillTemplateVariableToolbarDirective } from '../../../../shared/quill-template-variable.directive';
import { brandingFeature } from '../../../../state/branding.store';
import { DispatchActions } from '../../store/dispatch.actions';
import { DispatchFeature } from '../../store/dispatch.reducer';
@Component({
    selector: 'app-dispatch-send-schedule',
    standalone: true,
    imports: [FreyaCommonModule, QuillEditorComponent, ContextMenuModule, QuillTemplateVariableToolbarDirective],
    templateUrl: './dispatch-send-schedule.component.html',
    styleUrl: './dispatch-send-schedule.component.scss'
})
export class DispatchSendScheduleComponent implements OnDestroy {

    @Output() closeDialog = new EventEmitter<void>();

    @ViewChild('editor', { static: false }) editor: QuillEditorComponent | undefined
    @ViewChild('subjectEditor', { static: false }) subjectEditor: QuillEditorComponent | undefined

    public workingCrew$ = this.store.select(DispatchFeature.selectWorkingCrew);
    public selectedWorkingCrew$ = this.store.select(DispatchFeature.selectCrewScheduleRecepients);

    public templateVariableData$ = this.store.select(DispatchFeature.selectTemplateVariableData);
    public templateVariableData: ReturnType<typeof DispatchFeature.selectTemplateVariableData>;

    public templatesAndVariables$ = this.store.select(createSelector(
        brandingFeature.selectTemplates,
        (templates) => ({
            templates: templates.filter((template) => template.location === QuillTemplateLocation.DispatchSchedule),
            variables: TEMPLATE_VARIABLES[QuillTemplateLocation.DispatchSchedule],
        })
    ));

    private subs = new SubSink();

    constructor(
        private store: Store
    ) { }

    public editorContents: Delta;
    public subjectContents: Delta;
    public editorModules: QuillModules = {
        toolbar: commentDefaultToolbar,
        variableToolbar: true,
        templateToolbar: true,
    };
    public subjectModules: QuillModules = {
        toolbar: false,
        variableToolbar: { hideVariableButton: true },
    };

    // private setDefaultTemplate(defaultTemplate: QuillTemplate) {
    //     if (!defaultTemplate) {
    //         return;
    //     }
    //     const quillDelta = JSON.parse(defaultTemplate?.contents || '');
    //     this.editor.quillEditor.setContents(quillDelta);
    // }

    public onClose() {
        this.closeDialog.emit();
    }

    public onEditorCreated($event: any) {
        // this.watchTemplatesAndVariables();
        this.watchTemplateVariablesData();
    }

    public onSave() {
        this.store.dispatch(DispatchActions.crewScheduleSent({
            contents: this.editor?.quillEditor?.getContents(),
            subject: this.subjectEditor?.quillEditor?.getContents(),
        }));

        const updateSuccess$ = this.store.select(DispatchFeature.crewScheduleSendLoaded);

        // Subscribe to the success indicator
        this.subs.sink = updateSuccess$.subscribe((success) => {
            if (success) {
                this.operationSuccessfull();
            }
            // If not successful, do nothing and let the user adjust as needed
        });
    }

    private operationSuccessfull() {
        this.subs.unsubscribe();
        this.onClose()
    }

    // private updateTemplates(templates: QuillTemplate[]) {
    //     const templateToolbar = this.editor?.quillEditor?.getModule('templateToolbar') as TemplateToolbarQuillModule;
    //     if (templateToolbar) {
    //         templateToolbar.updateTemplates(templates);
    //     }
    // }

    // private updateVariables(variables: QuillVariable[]) {
    //     const variableToolbar = this.editor?.quillEditor?.getModule('variableToolbar') as VariableToolbarQuillModule;
    //     if (variableToolbar) {
    //         variableToolbar.updateVariables(variables);
    //     }
    // }

    private watchTemplateVariablesData() {
        this.subs.sink = this.templateVariableData$.subscribe((templateVariableData) => {
            this.templateVariableData = templateVariableData;
        });
    }

    // private watchTemplatesAndVariables() {
    //     this.subs.sink = this.templatesAndVariables$.subscribe((data) => {
    //         data.templates = data?.templates || [];
    //         const defaultTemplate = data.templates.find((t) => t.isDefault);
    //         this.setDefaultTemplate(defaultTemplate);
    //         this.updateTemplates(data.templates);
    //         this.updateVariables(data.variables);
    //     });
    // }

    public onCrewSelect(event: MultiSelectChangeEvent) {
        this.store.dispatch(DispatchActions.recepientsForCrewScheduleChanged({ recepients: event.value }));
        const crewData = event.value.length === 1
            ? this.templateVariableData.get(event.value[0].user.id)
            : {};
        const editors = [
            this.editor?.quillEditor?.getModule('variableToolbar') as VariableToolbarQuillModule,
            this.subjectEditor?.quillEditor?.getModule('variableToolbar') as VariableToolbarQuillModule
        ];
        editors.forEach(toolbar => {
            if (toolbar) {
                toolbar.updateData(crewData);
            }
        });
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
